export default __webpack_public_path__ + "static/media/Stroller.17e71556.png";